import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from '../locales/en.json';
import translationBahasa from '../locales/id.json';
import translationKannada from '../locales/kan.json';
import translationArabic from '../locales/ar.json';
import translationBengali from '../locales/bn.json';
import translationGerman from '../locales/de.json';
import translationSpanish from '../locales/es.json';
import translationGujarati from '../locales/gu.json';
import translationHindi from '../locales/hi.json';
import translationJapanese from '../locales/ja.json';
import translationMarathi from '../locales/mr.json';
import translationOdia from '../locales/or.json';
import translationRussian from '../locales/ru.json';
import translationChinese from '../locales/zh.json';
import translationFrench from '../locales/fr.json';
import translationItalian from '../locales/it.json';

i18n.use(initReactI18next).init({
  // we init with resources
  resources: {
    en: {
      translations: translationEnglish
    },
    kan: {
      translations: translationKannada
    },
    ar: {
      translations: translationArabic
    },
    bn: {
      translations: translationBengali
    },
    de: {
      translations: translationGerman
    },
    es: {
      translations: translationSpanish
    },
    gu: {
      translations: translationGujarati
    },
    hi: {
      translations: translationHindi
    },
    ja: {
      translations: translationJapanese
    },
    mr: {
      translations: translationMarathi
    },
    or: {
      translations: translationOdia
    },
    ru: {
      translations: translationRussian
    },
    it: {
      translations: translationItalian
    },
    fr: {
      translations: translationFrench
    },
    zh: {
      translations: translationChinese
    },
    id:{
      translations: translationBahasa
    }
  },
  fallbackLng: "en",
  debug: false,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;
